<template>
  <el-dialog :class="[currentTheme]"  :title="dialogName" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false"  :append-to-body='true'>
    <div class="main-box">
      <xr-data-table ref="xrDataTable" :configure="dataConfigure"></xr-data-table>
    </div>

  </el-dialog>

</template>

<script>

  export default {
    name: "orderList",
    data() {
      return {
        dialogName: '权益购买历史记录',
        dialogVisible: false,
        category_list:[],   //分类列表
        supplier_list:[],   //供应商列表
        drawer: false,
        isOrderShow: false,                      //是否显示订单详情页面
        isOrderEditShow: false,   //是否显示订单详情页面
        orgCategoryType: '',
        dataConfigure: {
          isShowSearch: true,
          defaultNoLoadData: true,
          isSelectFirst: true,
          listParam:{
            content: '',
          },
          pagination: false,
          idField: 'id',
          columns: [
            {
              field: 'sn',
              width: 60,
            },
            {
              field: 'createdTime',
              title: '购买时间',
              align: 'center',
              width: 200,
            },
            {
              field: 'money',
              title: '购买金额（元）',
              align: 'right',
              width: 200,
            },
            {
              field: 'comboName',
              title: '权益名称',
              align: 'center',
              width: 200,
            },
            {
              field: 'createUserName',
              title: '购买用户',
              align: 'center',
            }
          ],
          tableData:[   //数据列表
            {
              'createdTime':'2025-09-20 15:00:00',
              'money':'3000.00',
              'comboName':'3年权益',
              'money2':'4502.01',
              'createUserName':'用户1'
            }
          ]
        }
      }
    },
    computed: {
      orgCategory() {
        return this.$store.getters.orgCategory; //获取机构类型
      },
      orgId() {
        return this.$store.getters.orgId; //获取机构id
      },
      orgName() {
        return this.$store.getters.orgName; //获取机构名称
      },
      currentTheme() {
        return this.$store.getters.themeType; //获取当前的主题类型
      },
    },
    components: {

    },
    methods: {
      init(){
        this.dialogVisible = true;
      },
      //获取页面需要的参数
      getListInfo(){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method': 'tBusinessOrderInfo_getListInfo'
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          if(response.data && response.data.supplier_list){             //分类列表
            this.supplier_list = response.data.supplier_list;
          }
          if(response.data && response.data.category_list){             //分类列表
            this.category_list = response.data.category_list;
          }
        })
      },
      //查询
      search(){
        this.$refs.xrTable.getData();
      },
      //打开【新增】页面
      handleAddOpenDialog(){
        this.isGoodsAddOrEditShow = true;
        this.$nextTick(()=>{
          this.$refs.goodsAddOrEdit.resetTemp(); //重置页面数据
          this.$refs.goodsAddOrEdit.temp.supplierId = this.orgId;
          this.$refs.goodsAddOrEdit.temp.supplierName = this.orgName;
          this.$refs.goodsAddOrEdit.init('save') //初始化页面
        })
      },
      //信息修改
      handleEditOpenDialog(row){
        this.isOrderEditShow = true;
        this.$nextTick(()=>{
          this.$refs.orderEdit.resetTemp(); //重置页面数据
          this.$refs.orderEdit.init(row.id) //初始化页面
        })
      },
      //批量上架
      handleUpBatchOpenDialog(){
        //获取选中id数组
        let list = this.$refs.xrTable.multipleSelection;
        //判断是否选中
        if(list.length === 0){
          this.$message.warning("请至少选择一条记录！")
        }else {
          this.$confirm(`确定要上架选中的商品吗?`, '提示',
            {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then(() => {
            let ids = '';
            for(let i = 0;i < list.length;i++){
              ids = ids + list[i] + ",";
            }
            ids = ids.substring(0,ids.length-1);
            return this.request({
              method: 'post',
              url: '/web/service?method=tBusinessOrderInfo_upBatch',
              params: {
                'ids': ids
              }
            }).then((response) => {
              if (response.code != '0') {
                this.$message.error(response.msg);
                return false;
              }
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.$refs.xrTable.getData();
                }
              })
            })
          }).catch(() => {
          })
        }
      },
      handleDownBatchOpenDialog(){
        //获取选中id数组
        let list = this.$refs.xrTable.multipleSelection;
        //判断是否选中
        if(list.length === 0){
          this.$message.warning("请至少选择一条记录！")
        }else {
          this.$confirm(`确定要下架选中的商品吗?`, '提示',
            {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then(() => {
            let ids = '';
            for(let i = 0;i < list.length;i++){
              ids = ids + list[i] + ",";
            }
            ids = ids.substring(0,ids.length-1);
            return this.request({
              method: 'post',
              url: '/web/service?method=tBusinessOrderInfo_downBatch',
              params: {
                'ids': ids
              }
            }).then((response) => {
              if (response.code != '0') {
                this.$message.error(response.msg);
                return false;
              }
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.$refs.xrTable.getData();
                }
              })
            })
          }).catch(() => {
          })
        }
      },
      //打开详情页面
      handleViewOpenDialog(row){
        this.isOrderShow = true;
        this.$nextTick(()=>{
          this.$refs.orderView.init(row.id) //初始化页面
        })
      },
      //删除
      delete(row){
        this.$confirm(`确定要删除这条记录吗?`, '提示',
          {  confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
          return this.request({
            method:'post',
            url:'/web/service?method=tBusinessOrderInfo_delete',
            params: {
              'id': row.id
            }
          }).then((response) =>{
            if(response.code != '0'){
              this.$message.error(response.msg);
              return false;
            }
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.$refs.xrTable.getData();
              }
            })
          })
        }).catch(() => {})
      },
      toCateAgain(row){
        return this.request({
          method:'post',
          url:'/web/service?method=tBusinessOrderInfo_orderDetailToCartAgain',
          params: {
            'orderId': row.id
          }
        }).then((response) =>{
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
          })
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/header/combo-buy-list.vue